import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectNietInzetbaar = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.0899 9.85001L15.0999 13.5H16.1399L13.1599 2.73001C13.0599 2.29001 12.6399 2.01001 12.1999 2.01001H11.7999C11.3499 2.01001 10.9499 2.29001 10.8399 2.73001L5.7899 21H3.1499C2.8699 21 2.6499 21.22 2.6499 21.5C2.6499 21.78 2.8699 22 3.1499 22H12.7399V20.99H6.8299L7.9299 17H12.7299V16H8.1999L9.8999 9.84001H14.0799L14.0899 9.85001ZM10.1899 8.85001L11.7999 3.01001H12.1999L13.8099 8.85001H10.1899Z'
    />
    <path d='M18.58 18.62L21.11 16.09C21.31 15.89 21.31 15.58 21.11 15.38C20.91 15.18 20.6 15.18 20.4 15.38L17.87 17.91L15.34 15.38C15.14 15.18 14.83 15.18 14.63 15.38C14.43 15.58 14.43 15.89 14.63 16.09L17.16 18.62L14.63 21.15C14.43 21.35 14.43 21.66 14.63 21.86C14.73 21.96 14.86 22.01 14.98 22.01C15.1 22.01 15.24 21.96 15.33 21.86L17.86 19.33L20.39 21.86C20.49 21.96 20.62 22.01 20.74 22.01C20.86 22.01 21 21.96 21.09 21.86C21.29 21.66 21.29 21.35 21.09 21.15L18.56 18.62H18.58Z' />
  </svg>
);
export default SvgDefectNietInzetbaar;
